<template>
  <el-dialog title="登录" :visible.sync="myVisible" @close="syncValue" width="30%">
    <el-form ref="form" :model="form" label-width="80px" label-position="top">
      <el-form-item label="用户名：">
        <el-input v-model="form.username" placeholder="用户名/身份证号/手机号"></el-input>
      </el-form-item>
      <el-form-item label="密码：">
        <el-input type="password" v-model="form.password" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loginS">登录</el-button>
        <a href="/register" target="_blank">立即注册</a>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
    },
    components: {},
    data() {
      return {
        myVisible:this.visible,
        form: {
          username: '',
          password: ''
        }
      }
    },
    mounted() {
    },
    computed: {},
    methods: {
      ...mapActions([
        'userLogin'
      ]),
      syncValue(){
        this.$emit('update:visible', false)
      },
      loginS(){
        this.userLogin({
          username:this.form.username,
          password:this.form.password
        }).then((data) => {
          if(data.success){
            this.$message.success("登录成功");
            this.$emit('update:visible', false)
          }else{
            this.$message(data.msg);
          }
        }).catch(function (error) {
          this.$message.error('登录异常！');
        })
      }
    },
    watch: {
      visible(val){
        this.myVisible=val
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LoginLayer.vue